// extracted by mini-css-extract-plugin
module.exports = {"navlink":"Sidebar_navlink__1FyCB","navlinkActive":"Sidebar_navlinkActive__Xpgk0","logout":"Sidebar_logout__3jXqJ"};